import { ObjectType } from '~/static/enums/object-type'
import { ActualVersion as IconProps, migrate as migrateIcon } from '~/utils/editor/versioning/icon'
import { ActualVersion as ImageProps, migrate as migrateImage } from '~/utils/editor/versioning/image'
import { ActualVersion as SvgFigureProps, migrate as migrateSvgFigure } from '~/utils/editor/versioning/svg-figure'
import { ActualVersion as LineProps, migrate as migrateLine } from '~/utils/editor/versioning/line'
import { ActualVersion as TextProps, migrate as migrateText } from '~/utils/editor/versioning/text'

export interface Props {
  type?: ObjectType
  version?: number
}

export type VersionMigrator<T extends Props = Props> = (data: Props) => T

export type AnyActualProp = IconProps | ImageProps | SvgFigureProps | LineProps | TextProps

export type ActualProps = {
  [ObjectType.Icon]: IconProps
  [ObjectType.Image]: ImageProps
  [ObjectType.SvgFigure]: SvgFigureProps
  [ObjectType.Line]: LineProps
  [ObjectType.Text]: TextProps
}

export const migrate = <T extends ObjectType>(type: T, data: object): ActualProps[T] => {
  if (type === ObjectType.Icon) {
    return migrateIcon(data) as ActualProps[T]
  }
  if (type === ObjectType.Image) {
    return migrateImage(data) as ActualProps[T]
  }
  if (type === ObjectType.Text) {
    return migrateText(data) as ActualProps[T]
  }
  if (type === ObjectType.SvgFigure) {
    return migrateSvgFigure(data) as ActualProps[T]
  }
  return migrateLine(data) as ActualProps[T]
}
